import * as Styled from './TrackRowDragImage.styles'

import React from 'react'
import { TrackRowDragImageProps } from './TrackRowDragImage.types'

const TrackRowDragImage = React.forwardRef(
	({ track, ...props }: TrackRowDragImageProps, ref): JSX.Element => (
		<Styled.TrackRowDragImage {...props} ref={ref}>
			<Styled.TrackRowDragImageTitle>
				{track?.title}
			</Styled.TrackRowDragImageTitle>{' '}
			{track?.album.number}/{track?.albumTrackNumber}
		</Styled.TrackRowDragImage>
	)
)

TrackRowDragImage.displayName = 'TrackRowDragImage'

export default TrackRowDragImage
